var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccuralBalence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_477_577)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_477_577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112 0H16C7.16344 0 0 7.16344 0 16V112C0 120.837 7.16344 128 16 128H112C120.837 128 128 120.837 128 112V16C128 7.16344 120.837 0 112 0Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.649 26.5862H46.7241C46.2265 26.5862 45.883 26.9177 45.8219 27.3021C45.5053 29.2957 45.1151 32.3067 45.0208 35.4742C44.9253 38.6782 45.1395 41.8682 45.9286 44.3038C46.9097 47.3316 49.4252 50.4724 52.6102 53.4055C55.7543 56.301 59.3515 58.8147 62.2031 60.6228C65.5573 62.7495 65.5573 67.8804 62.2031 70.0071C59.3515 71.8153 55.7543 74.329 52.6102 77.2245C49.4252 80.1575 46.9097 83.2984 45.9286 86.3262C45.1395 88.7618 44.9253 91.9521 45.0208 95.1556C45.1151 98.3232 45.5053 101.335 45.8219 103.327C45.883 103.712 46.2265 104.044 46.7241 104.044H84.649C85.141 104.044 85.482 103.719 85.5478 103.341C85.8926 101.357 86.3273 98.3451 86.4642 95.1705C86.6027 91.9583 86.4269 88.7565 85.6576 86.3093C84.7091 83.2928 82.2277 80.1542 79.0731 77.218C75.9595 74.3199 72.3904 71.8013 69.5645 69.9914C66.2378 67.8608 66.2378 62.7692 69.5645 60.6385C72.3904 58.8286 75.9595 56.31 79.0731 53.4119C82.2277 50.4757 84.7091 47.3372 85.6576 44.3207C86.4269 41.8736 86.6027 38.672 86.4642 35.4597C86.3273 32.2846 85.8926 29.2722 85.5478 27.2887C85.482 26.9104 85.141 26.5862 84.649 26.5862ZM46.7241 24.5479C45.2774 24.5479 44.0334 25.5555 43.8066 26.9827C43.1576 31.0677 42.1941 39.3972 43.9872 44.9314C46.2756 51.994 55.2975 58.6585 61.1095 62.3437C63.201 63.6699 63.201 66.96 61.1095 68.2862C55.2975 71.9714 46.2756 78.6359 43.9872 85.6985C42.1941 91.2332 43.1576 99.562 43.8066 103.647C44.0334 105.075 45.2774 106.082 46.7241 106.082H84.649C86.079 106.082 87.3136 105.098 87.5583 103.69C88.2648 99.6242 89.3554 91.2674 87.6043 85.6985C85.3878 78.6483 76.4265 71.9649 70.6659 68.2755C68.5914 66.9469 68.5914 63.6831 70.6659 62.3545C76.4265 58.665 85.3878 51.9817 87.6043 44.9314C89.3554 39.3627 88.2648 31.0055 87.5583 26.94C87.3136 25.5326 86.079 24.5479 84.649 24.5479H46.7241Z",
    fill: "url(#paint0_linear_477_577)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.1723 42.0943C84.8735 41.5643 81.2685 41.8912 76.9315 42.2845C73.4561 42.5997 69.5106 42.9576 65.9052 42.9511C62.6852 42.9956 58.8141 42.6626 55.2711 42.3579C50.8108 41.9743 46.8706 41.6354 45.4051 42.1507C45.5403 42.9147 45.7132 43.6374 45.9291 44.3037C46.9101 47.3315 49.4257 50.4723 52.6106 53.4053C55.7547 56.3009 59.3519 58.8146 62.2035 60.6227C64.5098 62.0851 65.2303 64.9679 64.3649 67.3176C64.3628 68.2239 64.3271 69.2024 64.2897 70.2311C64.2349 71.7356 64.1762 73.3474 64.2126 74.9971C64.3481 81.1122 63.7026 86.7176 63.7026 86.7176C63.7026 86.7176 48.9389 89.5437 45.001 93.4749C44.9972 94.0325 45.0045 94.5935 45.0212 95.1555C45.1156 98.3231 45.5056 101.335 45.8224 103.327C45.8835 103.712 46.227 104.044 46.7245 104.044H84.6493C85.1414 104.044 85.4824 103.719 85.5481 103.341C85.893 101.357 86.3277 98.345 86.4646 95.1704C86.4798 94.8171 86.4913 94.4638 86.4986 94.1114C83.2755 89.3306 73.6442 87.828 69.3638 87.16C68.0768 86.9592 67.2735 86.8339 67.2735 86.7176V74.9971C67.2735 73.0784 67.2366 71.4177 67.2047 69.9791C67.1734 68.5725 67.1469 67.3783 67.1642 66.3625C66.7779 64.2393 67.5782 61.9108 69.5649 60.6384C72.3908 58.8285 75.9598 56.3099 79.0734 53.4118C82.2281 50.4756 84.7096 47.3371 85.6579 44.3206C85.8742 43.6326 86.0436 42.8851 86.1723 42.0943Z",
    fill: "url(#paint1_linear_477_577)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_477_577",
    x: 0,
    y: 0,
    width: 131,
    height: 131,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_477_577"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_477_577",
    x1: 65.7535,
    y1: 24.5479,
    x2: 65.7535,
    y2: 106.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7E7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_477_577",
    x1: 65.7492,
    y1: 41.8178,
    x2: 65.7492,
    y2: 104.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7804EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE00DA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_477_577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccuralBalence);
export default __webpack_public_path__ + "static/media/accural_balence.1f163d5b777ae2f3a05274f8e187f104.svg";
export { ForwardRef as ReactComponent };